import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BluetoothIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.75 11.3987L9.82846 10.5L8.75 9.60129V11.3987Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.75 6.39873L9.82846 5.50001L8.75 4.60129V6.39873Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 1C5.23858 1 2 3.23858 2 6V10C2 12.7614 5.23858 15 8 15C10.7614 15 14 12.7614 14 10V6C14 3.23858 10.7614 1 8 1ZM8.48392 13.573C8.35845 13.6791 8.19769 13.7447 8.02175 13.7497C8.00267 13.7503 7.98356 13.7501 7.96445 13.7492C7.75232 13.7393 7.56322 13.6413 7.43293 13.4909C7.31896 13.3593 7.25 13.1877 7.25 13V9.60129L5.48014 11.0762C5.16193 11.3413 4.68901 11.2984 4.42383 10.9801C4.15866 10.6619 4.20165 10.189 4.51986 9.92384L6.82846 8.00001L4.51986 6.07617C4.20165 5.811 4.15866 5.33808 4.42383 5.01987C4.68901 4.70166 5.16193 4.65867 5.48014 4.92384L7.25 6.39873V3.00001C7.25 2.81222 7.31902 2.64055 7.43307 2.50898C7.46283 2.47461 7.4958 2.44285 7.53167 2.41417C7.65137 2.31835 7.80108 2.25846 7.96446 2.25084C7.98356 2.24993 8.00267 2.24976 8.02175 2.25032C8.19769 2.25533 8.35846 2.32093 8.48393 2.427L11.4801 4.92384C11.6511 5.06634 11.75 5.27742 11.75 5.50001C11.75 5.72259 11.6511 5.93368 11.4801 6.07618L9.17154 8.00001L11.4801 9.92384C11.6511 10.0663 11.75 10.2774 11.75 10.5C11.75 10.7226 11.6511 10.9337 11.4801 11.0762L8.48392 13.573Z"
		></path>
	</svg>
))
